import { useEffect, useRef } from "react";

const usePrevious = (state) => {
    const previous = useRef();
    useEffect(() => {
        previous.current = state;
    }, [state]);
    return previous.current;
}

export default usePrevious;